import React from "react";

/**
 * Offizielles Logo, 1:1 wie geliefert - kein Zuschnitt, keine Farbaenderung.
 * Die Wortmarke "Pension Günding Gästehaus" ist Teil des Logos, daher steht daneben kein
 * zusaetzlicher Schriftzug mehr.
 */
export function LogoMark({ className = "h-14 lg:h-16" }) {
  return (
    <img
      src="/images/logo.jpg"
      alt="Pension Günding Gästehaus"
      loading="eager"
      decoding="async"
      fetchpriority="high"
      className={`w-auto shrink-0 rounded-lg object-contain ${className}`}
    />
  );
}

export default function Logo({ className = "h-14 lg:h-16" }) {
  return <LogoMark className={className} />;
}
